import { SemiosLogoColor } from 'components/SemiosLogo/SemiosLogoColor'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import { colors } from 'settings/colors'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

export const ReportHeader = ({ dateFrom, dateTo }: { dateFrom: string; dateTo: string }) => {
  const selectedPropertyId = selectedFieldAssetsStore.useSelector((s) => s.property)
  const selectedProperty = fieldAssetStore.useSelector((s) => s.properties)?.[Number(selectedPropertyId)]
  const userDetailsStoreState = userDetailsStore.useSelector((s) => s)

  if (!selectedProperty?.timezone) return null

  const { propertyName, timezone } = selectedProperty
  const firstDayMoment = moment.tz(dateFrom, timezone)
  const lastDayMoment = moment.tz(dateTo, timezone)
  const isValidDateRange = dateFrom && dateTo && firstDayMoment.isValid() && lastDayMoment.isValid()
  const firstDayFormatted = translate.dates.format(firstDayMoment, 'MMM D')
  const lastDayFormatted = translate.dates.format(lastDayMoment, 'MMM D, YYYY')
  const dateString = isValidDateRange ? `${firstDayFormatted} - ${lastDayFormatted}` : ''

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        padding: '10px 0px',
        borderBottom: `1px solid ${colors.grey200}`,
      }}
    >
      <div>
        <SemiosLogoColor width={150} />
        <h3 css={{ marginTop: 5, marginBottom: 5 }}>{translate.phrases.banyanApp('Weekly Water Report')}</h3>
        <h3 css={{ marginTop: 5, marginBottom: 5 }}>{propertyName}</h3>
        <h4>{dateString}</h4>
      </div>
      <div css={{ fontSize: 12, textAlign: 'right' }}>
        <div>
          {translate.phrases.banyanApp('Generated On: {{todayDate}}', {
            todayDate: translate.dates.format(moment.tz(timezone), 'MMM D, YYYY'),
          })}
        </div>
        <div>
          {translate.phrases.banyanApp('Generated by: {{name}}', {
            name: `${userDetailsStoreState?.firstName} ${userDetailsStoreState?.lastName}`,
          })}
        </div>
      </div>
    </div>
  )
}
